import './ProfileIcon.scss'

export default function ProfileIcon({ profileColor, className, size = 1.5 }) {
	return (
		<div className={`profile-icon ${className}`} style={{ backgroundColor: profileColor, '--size': `${size}rem` }}>
			<i className="fa-fw fa-solid fa-chart-simple" />
		</div>
	)
}
